import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=09f11e08&scoped=true&"
import script from "./PostPreview.vue?vue&type=script&lang=js&"
export * from "./PostPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostPreview.vue?vue&type=style&index=0&id=09f11e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f11e08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f11e08')) {
      api.createRecord('09f11e08', component.options)
    } else {
      api.reload('09f11e08', component.options)
    }
    module.hot.accept("./PostPreview.vue?vue&type=template&id=09f11e08&scoped=true&", function () {
      api.rerender('09f11e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/feed/PostPreview.vue"
export default component.exports